import React, { useState, useEffect, useContext } from "react";
import { Formik, Field, isEmptyArray } from "formik";
import {
  Row,
  Col,
  Button,
  Toast,
  Form,
  InputGroup,
  Image,
  Tabs,
  Tab,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faTimesCircle,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import {
  SliderPanel,
  CsplTable as Table,
  FormControlSearch,
  ManagePayrollTabLayout,
  LoaderWrapper,
} from "../../../../components";
import { useRouterParams } from "../../../../abstracts";
import {
  acceptAllWarningsInaFile,
  acceptWarningByMessageCode,
  getWarningsInECR,
  getErrorsInECR,
  getRecordDetailsInGetWarningScreen,
  acceptAllDataChangeValidationInaFile,
  acceptEmployeeWarnings,
  getAllRecords,
  getEmployeeClassificationType,
  getFileInformationByFileId,
  getTempEmployeeDetailsforPayroll,
} from "../../../../services";
import {
  errors,
  usDateFormat,
  ssnMasking,
  EMPLOYEE_RECORDS_TO_FETCH,
  formFields,
  getAdvancedPathWithParam,
  managePayrollFormNames,
  ROUTES,
  scrollToErrorControl,
  MANAGE_PAYROLL_ROUTES,
  UploadedFileType,
} from "../../../../utils";
import { useDeepEffect } from "../../../../abstracts";
import InfiniteScroll from "react-infinite-scroller";
import AddToolTip from "../../../../components/AddToolTip";
import authService from "../../../../components/api-authorization/AuthorizeService";
import permissions from "../../../../mocks/menuPermissions.json";
import { camelCase, get, isEmpty } from "lodash";
import CensusFormDetails from "../../ErrorFoundInRecordsContainer/CensusFormDetails";
import { useHistory } from "react-router-dom";
import PayrollFormDetails from "../../ErrorFoundInRecordsContainer/PayrollFormDetails";
import { managePayrollStore } from "../../../../contexts";
const columns = [
  {
    label: "SSN",
    className: "column-custodianName",
    columnName: "ssn",
  },
  {
    label: "Employee name",
    className: "column-custodianMail",
    columnName: "employeeName",
  },
  {
    label: "Pay date",
    className: "column-custodianPhone",
    columnName: "payDate",
  },
];

const WarningReports = (props) => {
  const {
    NoOfErrors,
    setIsLoading,
    isLoading,
    fileId,
    toggleUseEffect,
    tabChange,
    setEcrSubmit,
    toggleAcceptWarning,
    menu,
    subMenu,
    revalidateIds,
    revalidateFile,
    setErrorPage = () => {},
    setIsModalOpen = false,
    allRecords,
    onClick,
    countries,
    states,
    frequencyList,
  } = props;
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalLoader, setModalLoader] = useState(false);
  const [warningRecords, setWarnings] = useState([]);
  const [msgCode, setMsgCode] = useState({});
  const [selectedList, setSelectedList] = useState([]);
  const [acceptedRecordList, setAcceptedRecordList] = useState([]);
  const [toggle, setToggle] = useState(true);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [append, setAppend] = useState(false);
  const [displayEmployeeName, setDisplayEmployeeName] = useState("");
  const [displaySsn, setDisplaySsn] = useState("");
  const [displayPayDate, setDisplayPayDate] = useState("");
  const [displayEmployeeId, setDisplayEmployeeId] = useState(null);
  const { state, dispatch } = useContext(managePayrollStore);
  const fileTypeInformation = get(state, "api.data.fileType");
  const [selectedTabIndex, setTabIndex] = useState("warning");
  const [censusTabIndex, setCensusTabIndex] = useState(
    UploadedFileType.IsPayrollOnly === fileTypeInformation
      ? "payroll"
      : "census"
  );
  const [fileInfoData, getFileInfoData] = useState([]);
  //const [append, setAppend] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [toggleEmp, setToggleEmp] = useState(false);
  const [employeeData, setEmployeeData] = useState(null);
  const [existingEmployeeData, setExistingEmployeeData] = useState(null);
  const fields = formFields[managePayrollFormNames.ERROR_CORRECTION_FORM];
  //const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  // const [filteredValues, setFilteredValues] = useState([]);
  // const [acceptedWarningRecords, setAcceptedWarningRecords] = useState([]);
  const [payrollWarnings, setPayrollWarnings] = useState([]);
  const [censusWarnings, setCensusWarnings] = useState([]);
  const [payrollErrors, setPayrollErrors] = useState([]);
  const [censusErrors, setCensusErrors] = useState([]);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [dataChangeValidations, setDataChangeValidations] = useState([]);
  const [employeeInfo, setEmployeeInfo] = useState({});
  const [errorList, setErrorList] = useState({});
  const [isStartDate, setIsStartDate] = useState(false);
  const [isEndDate, setIsEndDate] = useState(false);
  const [census, setCensus] = useState();
  const [classificationList, setClassificationList] = useState();
  const [isSubmit, setIsSubmit] = useState(false);
  const payrollDetails = get(state, "api.data", {});
  const { payrollId, employeeId } = useRouterParams();
  const history = useHistory();

  const [deleteContributionId, setDeleteContributionId] = useState([]);
  const contirbutionIds = [...new Set(deleteContributionId)];
  const [deleteCompensationError, setDeleteCompensationError] = useState([]);
  const compensationIds = [...new Set(deleteCompensationError)];
  const [hoursErrorId, setHoursErrorId] = useState([]);
  const [request, setRequest] = useState({
    fileId: payrollId,
    from: 0,
    offset: EMPLOYEE_RECORDS_TO_FETCH,
    searchInput: "",
  });
  // const [request, setRequest] = useState({
  //   fileId: fileId,
  //   from: 0,
  //   offset: 20,
  // });
  //const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  useDeepEffect(() => {
    setIsLoading(true);
    getWarningsInECR(request).then((response) => {
      setIsLoading(false);
      if (response?.length < EMPLOYEE_RECORDS_TO_FETCH)
        setStopInfiniteScroll(true);
      if (append && searchTerm == "")
        setWarnings((warningRecords) => {
          return [
            ...warningRecords,
            ...response.filter((x) => x.referenceId !== 0).map((x) => x),
          ];
        });
      else
        setWarnings(response.filter((x) => x.referenceId !== 0).map((x) => x));
      setIsLoading(false);
    });
  }, [toggle, request]);
  useDeepEffect(() => {
    if (searchTerm == "") setRequest({ ...request, from: 0, searchInput: "" });
    else {
      setRequest({
        ...request,
        from:
          warningRecords?.length - EMPLOYEE_RECORDS_TO_FETCH < 0
            ? 0
            : warningRecords?.length - EMPLOYEE_RECORDS_TO_FETCH,
        searchInput: searchTerm,
      });
    }
  }, [searchTerm]);
  // useEffect(() => {
  //   getErrorsInECR(request).then((response) => {
  //     setErrorList(response);
  //   });
  // }, [toggle]);

  const refresh = () => {
    setToggle(!toggle);
  };
  const handleSearchChange = (e) => {
    const val = e.target.value;
    setSearchTerm(val);
    if (!stopInfiniteScroll) {
      setAppend(false);
    }
  };
  const [showToast, setShowToast] = useState(false);
  const [showToastAll, setShowToastAll] = useState(false);
  const [showAllToastMsg, setShowAllToastMsg] = useState([]);

  const handleAcceptAll = () => {
    acceptAllWarningsInaFile(fileId).then((response) => {
      toggleAcceptWarning();
      if (response) {
        const updatedList = warningRecords.map((item) => {
          return item;
        });
        //setAcceptedWarningRecords(updatedList);
        // setAcceptedWarningRecords((acceptedWarningRecords) => {
        //   return [...acceptedWarningRecords, ...updatedList];
        // });
        toggleUseEffect();
        refresh();
        if (NoOfErrors === 0) {
          setEcrSubmit(true);
        }
        // setShowAllToastMsg(updatedList);
        // setShowToastAll(true);
        // if (NoOfErrors === 0) {
        //   setEcrSubmit(true);
        //   tabChange(3);
        //   history.push(
        //     getAdvancedPathWithParam({
        //       path: `${ROUTES.PAYROLL_FILE_STATUS}/${payrollId}/?tab=3`,
        //     })
        //   );
        // }
      }
    });
  };

  const undoAll = () => {
    const updatedList = warningRecords.map((item) => {
      return item;
    });
    setShowToastAll(false);
    setShowToast(false);
  };
  // const [censusTabIndex, setCensusTabIndex] = useState("census");
  // const onCensusTabSelect = (id) => {
  //   setCensusTabIndex(id);
  // };
  const undo = () => {
    const data = [...warningRecords, ...showAllToastMsg];
    setShowToast(false);
  };
  const handleAccept = (id, messageCode, lookUpIds) => {
    // let newData = Reports.filter((item) => {
    //   return item.id === id;
    // });
    // setShowAllToastMsg(newData);
    // const Lists = Reports.filter((val) => val.id !== id);
    // setWarningReports(Lists);
    if (warningRecords?.length === 1 && NoOfErrors == 0) {
      setEcrSubmit(true);
      // tabChange(3);
      // history.push(
      //   getAdvancedPathWithParam({
      //     path: `${ROUTES.PAYROLL_FILE_STATUS}/${payrollId}/?tab=3`,
      //   })
      // );
    }
    acceptWarningByMessageCode(id, messageCode, lookUpIds).then((response) => {
      if (response) {
        setIsLoading(false);
        toggleUseEffect();
        refresh();
        toggleAcceptWarning();
      }
    });
    // setShowToast(true);
    setModalOpen(false);
  };

  const acceptCommonWarning = (id) => {
    const selected = warningRecords.filter((item) => {
      return id === item.lookUpId;
    });

    const lookUpId = selected.flatMap((x) => x.lookUpId);
    acceptWarningByMessageCode(fileId, selected[0].messageCode, lookUpId).then(
      (response) => {
        if (response) {
          setIsLoading(false);
          // setAcceptedWarningRecords((acceptedWarningRecords) => {
          //   return [...acceptedWarningRecords, ...selected];
          // });
          toggleUseEffect();
          refresh();
          toggleAcceptWarning();
        }
      }
    );
    // setShowToast(true);
    setModalOpen(false);
  };

  const showPopup = (id) => {
    const selected = warningRecords.filter((item) => {
      return id === item.lookUpId;
    });
    const lookUpId = selected.flatMap((x) => x.lookUpId);

    setModalOpen(true);
    setDisplayEmployeeId(null);
    getRecordDetailsInGetWarningScreen({
      fileId: fileId,
      lookUpIds: lookUpId,
    }).then((response) => {
      var recordResponce = response.map((_, index) => {
        return { ..._, lookUpId: lookUpId[index] };
      });
      setSelectedList(recordResponce);
      setAcceptedRecordList([]);
      setDisplayEmployeeName(recordResponce[0].employeeName);
      setDisplaySsn(recordResponce[0].ssn);
      setDisplayPayDate(recordResponce[0].payDate);
      setDisplayEmployeeId(recordResponce[0].id);
    });
    setMsgCode({
      messageCode: selected[0].messageCode,
      messageDescCode: selected[0].messageDescCode,
      lookUpId: lookUpId,
    });
  };

  let accpectedIds = contirbutionIds.concat(compensationIds, hoursErrorId);
  useDeepEffect(() => {
    accpectedIds = contirbutionIds.concat(compensationIds, hoursErrorId);
  }, [hoursErrorId]);
  const [roleName, setRoleName] = useState("SPU");
  // useEffect(() => {
  //   getRole();
  // }, []);
  // const getRole = async () => {
  //   setRoleName(await authService.getRole());
  // };
  let fileValue = "",
    systemValue = "";

  const onCensusTabSelect = (id) => {
    setCensusTabIndex(id);
  };

  useEffect(() => {
    getFileInformationByFileId(payrollId).then((res) => {
      getFileInfoData(res);
    });
  }, [payrollId]);
  useEffect(() => {
    if (!isEmptyArray(deleteContributionId))
      acceptEmployeeWarnings({
        acceptedWarningIds: deleteContributionId,
        fileUploadId: employeeData.fileUploadId,
      });
  }, [deleteContributionId]);
  useEffect(() => {
    if (!isEmptyArray(deleteCompensationError))
      acceptEmployeeWarnings({
        acceptedWarningIds: deleteCompensationError,
        fileUploadId: employeeData.fileUploadId,
      });
  }, [deleteCompensationError]);

  const fileStatus = get(state, "api.data.fileStatus", {});
  const pendingSubmission =
    fileStatus === "AwaitingFunding" ||
    fileStatus === "AwaitingFundConfirmation" ||
    fileStatus === "AwaitingTrade"
      ? true
      : false;

  const onPayrollDeleteClick = () => {
    setIsModalOpen(true);
  };
  const acceptWarnings = (warningId, employeeName) => {
    setModalLoader(true);
    acceptEmployeeWarnings({
      acceptedWarningIds: [warningId],
      fileUploadId: fileId,
    }).then((response) => {
      if (response) {
        setSelectedList(
          selectedList.filter((_) => {
            return _.lookUpId !== warningId;
          })
        );
        // setDisplayEmployeeId(employeeId)
        setDisplayEmployeeName(employeeName);
        setAcceptedRecordList([
          ...acceptedRecordList,
          ...selectedList.filter((_) => {
            return _.lookUpId === warningId;
          }),
        ]);
        getWarningsInECR(request).then((response) => {
          if (response?.length < EMPLOYEE_RECORDS_TO_FETCH)
            setStopInfiniteScroll(true);
          if (append)
            setWarnings((warningRecords) => {
              return [
                ...warningRecords,
                ...response.filter((x) => x.referenceId !== 0).map((x) => x),
              ];
            });
          else
            setWarnings(
              response.filter((x) => x.referenceId !== 0).map((x) => x)
            );
        });
        setModalLoader(false);
      }
    });
  };

  const isAllowedUpdate = () => {
    return permissions[roleName][menu + "SubMenu"][camelCase(subMenu)].includes(
      "U"
    );
  };
  const isAllowedDelete = () => {
    return permissions[roleName][menu + "SubMenu"][camelCase(subMenu)].includes(
      "D"
    );
  };

  useEffect(() => {
    setIsLoading(true);
    if (displayEmployeeId !== null) {
      setCensus(false);
      getTempEmployeeDetailsforPayroll(displayEmployeeId).then((response) => {
        setIsLoading(false);
        setEmployeeData(response);
        setExistingEmployeeData({ ...response });
        if (response.leaveStartDate == null) setIsStartDate(false);
        else setIsStartDate(true);
        if (response.leaveEndDate == null) setIsEndDate(false);
        else setIsEndDate(true);
        // let c = response.contributions.map((_) => _.errorMessages);
        // var merged = response.errorMessages.concat.apply([], c);
        // merged.forEach((_) => response.errorMessages.push(_));
        // var error = {}
        // response.errorMessages.forEach(_=> error[_.controlName]=_.MessageDescCode);
        // setErrors(error);
        let payrollMapData = response.errorMessages.filter(
          (_) => _.errorType == 2 && _.processReferenceId != 2
        );
        setPayrollWarnings(
          payrollMapData.map((data) => {
            return { ...data, checked: false };
          })
          //c[0].filter((_)=>_.errorType==2 && _.processReferenceId != 2)
        );
        if (response.companyId != null) {
          getEmployeeClassificationType(response.companyId).then(
            (response1) => {
              setClassificationList(response1);
            }
          );
        }
        let censusMapData = response.errorMessages.filter(
          (_) => _.errorType == 2 && _.processReferenceId == 2
        );
        setCensusWarnings(
          censusMapData.map((data) => {
            return { ...data, checked: false };
          })
        );
        var payrollError = response.errorMessages.filter(
          (_) => _.errorType == 1 && _.processReferenceId != 2
        );

        response.contributions?.forEach((_) => {
          _.errorMessages?.forEach((_) => {
            if (_.errorType == 1) payrollError.push(_);
          });
        });
        response.payrollLoans?.forEach((_) => {
          _.errorMessages?.forEach((_) => {
            if (_.errorType == 1) payrollError.push(_);
          });
        });

        var dataValidationErrorCount = response.errorMessages?.filter(
          (_) => _.errorType === 3
        );
        dataValidationErrorCount.forEach((_) => {
          _["dataToSave"] = true;
        });
        if (dataValidationErrorCount.length > 0) {
          setIsSliderOpen(true);
        }
        var notification = response.errorMessages.filter(
          (x) => x.errorType === 4
        );
        setEmployeeInfo({
          employeeName: response.firstName + response.lastName,
          uniqueId: response.uniquePersonalIdentification,
        });

        var payrollWarning = response.errorMessages.filter(
          (_) => _.errorType == 2 && _.processReferenceId != 2
        );

        response.contributions?.forEach((_) => {
          _.errorMessages?.forEach((_) => {
            if (_.errorType == 2) payrollWarning.push(_);
          });
        });
        response.payrollLoans?.forEach((_) => {
          _.errorMessages?.forEach((_) => {
            if (_.errorType == 2) payrollWarning.push(_);
          });
        });
        if (notification.length > 0) setModalOpen(true);
        setPayrollErrors(payrollError);
        setNotifications(notification);
        setDataChangeValidations(dataValidationErrorCount);
        setPayrollWarnings(
          payrollWarning.map((data) => {
            return { ...data, checked: false };
          })
        );
        setCensusErrors(
          response.errorMessages.filter(
            (_) => _.errorType == 1 && _.processReferenceId == 2
          )
        );
        setCensus(true);
      });
    }
  }, [displayEmployeeId]);

  // useDeepEffect(() => {
  //   getAllRecords(request)
  //     .then((response) => {
  //       if (response.errorReportDetails?.length < EMPLOYEE_RECORDS_TO_FETCH)
  //         setStopInfiniteScroll(true);
  //       if (append && searchTerm == "")
  //         setFilteredValues([
  //           ...filteredValues,
  //           ...response.errorReportDetails,
  //         ]);
  //       else {
  //         setFilteredValues(response.errorReportDetails);
  //         setStopInfiniteScroll(false);
  //       }
  //       setIsLoading(false);
  //     })

  //     .catch((error) => {});
  // }, [request]);

  return (
    <div>
      <div className="search-bar-warning-page d-flex-row mt-3 justify-content-space-between">
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            setRequest({
              ...request,
              from:
                warningRecords?.length - EMPLOYEE_RECORDS_TO_FETCH < 0
                  ? 0
                  : warningRecords?.length - EMPLOYEE_RECORDS_TO_FETCH,
              searchInput: searchTerm,
            });
          }}
        >
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text className="plan-search-button">
                <Image src="/assets/icons/svg/search.svg" width="14px" />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <FormControlSearch
              type="search"
              placeholder="Search warning name"
              onChange={handleSearchChange}
              // onKeyPress={(event) => {
              //   if (event.key === "Enter") {
              //     event.preventDefault();
              //   }
              // }}
            />
          </InputGroup>
        </Form>

        {/* <div
          className="link-text-mapper ft-14 cursor-pointer"
          style={{
            marginRight: "5px",
            marginTop: "8px",
          }}
          onClick={() => {
            revalidateIds(revalidateFile);
          }}
        >
          <i class="fa fa-retweet mr-2" aria-hidden="true"></i>Revalidate
        </div> */}
      </div>
      {/* <Col md="8">Warning</Col>
        <Col md="2">No of records</Col> */}
      <div
        className="error-types-box-var1 font-weight-500 mt-2 d-flex justify-content-space-between"
        style={{ width: "100%" }}
      >
        <Col md="5" className="grey-text">
          Warnings
        </Col>
        <Col md="3" className="grey-text">
          Records{" "}
        </Col>
        {isAllowedUpdate() && warningRecords.length !== 0 ? (
          <Col md="3" className="primary-small">
            <span
              className="cursor-pointer text-underline fw-600"
              onClick={() => {
                handleAcceptAll();
              }}
            >
              Accept All
            </span>
          </Col>
        ) : (
          <Col md="3" className="primary-small"></Col>
        )}
      </div>
      {/* <Col md="2">
          {warningRecords.length < 1 ? (
            ""
          ) : permissions[roleName][menu + "SubMenu"][
              camelCase(subMenu)
            ].includes("U") ? (
            <span onClick={handleAcceptAll} className={"link-text pointer"}>
              <a className="new-linkText mt-0">Accept All</a>
            </span>
          ) : null}
        </Col> */}
      <div
        className="cursor-pointer validation-error-report w-100"
        //style={{ overflowY: "scroll", height:"60vh" }}
      >
        <InfiniteScroll
          pageStart={0}
          loadMore={() => {
            setAppend(true);
            setRequest((request) => {
              return {
                ...request,
                from: warningRecords?.length,
                searchInput: searchTerm,
              };
            });
          }}
          hasMore={!stopInfiniteScroll}
          initialLoad={false}
          threshold={100}
          useWindow={false}
          loader={
            isLoading ? (
              <div className="loader" key={0}>
                Loading ...
              </div>
            ) : null
          }
        >
          {warningRecords.length <= 0 ? (
            <div className="no-found">No Warnings Found</div>
          ) : (
            warningRecords.map((warning, index) => (
              <Row
                className="error-types-box-var font-weight-400 mt-3 cursor-pointer"
                key={index}
                style={{ width: "100%" }}
                onClick={() => showPopup(warning.lookUpId)}
              >
                <Col md="6">
                  <AddToolTip
                    className="short-desc"
                    name={`${warning.messageCode} ${warning.messageDescCode}`}
                    placement="bottom"
                  >
                    {`${warning.messageCode} ${warning.messageDescCode}`.slice(
                      0,
                      50
                    )}
                    ...
                  </AddToolTip>
                </Col>
                <Col md="3">
                  <span
                    // onClick={() => showPopup(warning.lookUpId)}
                    className="pointer link-text"
                  >
                    {warning.noOfRecords}
                  </span>
                </Col>
                {isAllowedUpdate() && (
                  <Col
                    md="3"
                    onClick={(e) => {
                      e.stopPropagation();
                      acceptCommonWarning(warning.lookUpId);
                    }}
                    className="text-underline primary-small"
                    style={{ cursor: "pointer" }}
                  >
                    Accept
                  </Col>
                )}
              </Row>
            ))
          )}

          {/* {acceptedWarningRecords.map((warning, index) => (
            <Row
              className="error-types-box-var font-weight-400 mt-3 cursor-pointer"
              key={index}
              style={{ width: "100%" }}
              onClick={() => showPopup(warning.lookUpId)}
            >
              <Col md="6">
                <AddToolTip
                  className="short-desc"
                  name={`${warning.messageCode} ${warning.messageDescCode}`}
                  placement="bottom"
                >
                  {`${warning.messageCode} ${warning.messageDescCode}`.slice(
                    0,
                    50
                  )}
                  ...
                </AddToolTip>
              </Col>
              <Col md="3">
                <span
                  // onClick={() => showPopup(warning.lookUpId)}
                  className="pointer link-text"
                >
                  {warning.noOfRecords}
                </span>
              </Col>
              <Col
                md="3"
                // onClick={(e) => {
                //   e.stopPropagation();
                //   acceptCommonWarning(warning.lookUpId);
                // }}
                style={{ color: "#00FF00", cursor: "pointer" }}
              >
                Accepted
              </Col>
            </Row>
          ))} */}
          {/* <div className="no-found">
            {warningRecords < 1 && stopInfiniteScroll ? "No warnings" : ""}
          </div> */}
        </InfiniteScroll>
      </div>
      <LoaderWrapper isLoading={isModalLoader}>
        <SliderPanel
          isOpen={isModalOpen}
          size={85}
          showCancel={false}
          showBackButton={false}
          backdropClicked={() => setModalOpen(false)}
        >
          <div style={{ height: "88vh", overFlowY: "auto" }}>
            <div className="d-flex justify-content-between p-2 mt-0">
              <div className="ft-22 font-weight-600">Warning Details</div>

              <Button
                type="button"
                variant="secondary"
                onClick={() => {
                  setModalOpen(false);
                  setCensusTabIndex("census");
                }}
              >
                Close
              </Button>
            </div>
            <div className="border-top mt-1" />
            <div className="mtb-30 ft-14 d-flex warning-header">
              <i
                class="fa fa-exclamation-circle mr-3"
                aria-hidden="true"
                style={{ color: "#A05A06", marginTop: "0.4%" }}
              ></i>{" "}
              <AddToolTip
                className="short-desc color_A05A06 ft-14 font-weight-600 "
                name={` ${msgCode && msgCode.messageCode} -
                ${msgCode && msgCode.messageDescCode}`}
                placement="bottom"
              >
                {msgCode && msgCode.messageCode} -{" "}
                {msgCode && msgCode.messageDescCode}
              </AddToolTip>
            </div>
            <div className="d-flex justify-content-space-between ml-3">
              <div className="w-25" style={{ borderRight: "1px solid black" }}>
                <div className="d-flex ">
                  {/* {permissions[menu + "SubMenu"][
                  camelCase(subMenu)
                ].includes("U") ? (
                  <Button
                    onClick={() =>
                      handleAccept(
                        fileId,
                        msgCode.messageCode,
                        msgCode.lookUpId
                      )
                    }
                  >
                    Accept Warning
                  </Button>
                ) : null} */}
                  <Col>
                    <Row>
                      <p className="mt-10 font-weight-600 ft-20 mb-1">
                        Records
                      </p>
                    </Row>
                    <Row>
                      <p className="font-weight-600 ft-14 grey-text-sub">
                        {selectedList && selectedList.length} found
                      </p>
                    </Row>
                  </Col>
                  {isAllowedUpdate() && (
                    <p
                      onClick={() =>
                        handleAccept(
                          fileId,
                          msgCode.messageCode,
                          msgCode.lookUpId
                        )
                      }
                      className="primary-small mt-20 fw-700 ft-14 cursor-pointer text-underline"
                      style={{ marginRight: "5%" }}
                    >
                      Accept all
                    </p>
                  )}
                </div>
                {/* <div
                className="error-types-box-var1 font-weight-500 mt-2 d-flex justify-content-space-between"
                style={{ width: "100%" }}
              >
                <Col md="6" className="grey-text">
                  Employee Name & SSN <i className="fas fa-sort"></i>
                </Col>
                <Col md="3" className="grey-text">
                  Paydate <i className="fas fa-sort"></i>{" "}
                </Col>
                <Col md="3" className="grey-text">
                  Action<i className="fas fa-sort"></i>
                </Col>
              </div> */}
                <div
                  style={{
                    overflow: "scroll",
                    height: "52vh",
                    marginRight: "5%",
                  }}
                >
                  {selectedList &&
                    selectedList.map((warning, index) => (
                      <Row
                        className="error-types-box-var-warning font-weight-400 mt-3 justify-content-space-between"
                        key={index}
                        style={{ maxWidth: "340px" }}
                        onClick={() => {
                          setDisplayEmployeeName(warning.employeeName);
                          setDisplaySsn(warning.ssn);
                          setDisplayPayDate(warning.payDate);
                          setDisplayEmployeeId(warning.id);
                          //onClick(allRecords, warning.id);
                        }}
                      >
                        <Col md="5" className="align-self-center black-text">
                          <Row className="ml-1 fw-600">
                            {/* {warning.employeeName}  */}
                            {warning.employeeName.length > 12 ? (
                              <AddToolTip name={warning.employeeName}>
                                {warning.employeeName.slice(0, 12)}...
                              </AddToolTip>
                            ) : (
                              warning.employeeName
                            )}
                          </Row>
                          <Row className="ml-1 grey-text-sub">
                            {" "}
                            {ssnMasking(warning.ssn)}{" "}
                          </Row>
                        </Col>
                        <Col md="4" className="align-self-center black-text">
                          <div className="d-flex flex-column justify-content-center">
                            <div className="grey-text-sub">Pay date</div>
                            <div className="fw-600">
                              {usDateFormat(warning.payDate)}
                            </div>
                          </div>
                        </Col>
                        {isAllowedUpdate() && (
                          <Col
                            onClick={() =>
                              acceptWarnings(
                                warning.lookUpId,
                                warning.employeeName
                              )
                            }
                            md="3"
                            className="primary-small align-self-center black-text cursor-pointer text-underline primary-color"
                          >
                            Accept
                          </Col>
                        )}
                      </Row>
                    ))}
                  {acceptedRecordList &&
                    acceptedRecordList.map((warning, index) => (
                      <Row
                        className="accepted-warning-box-var font-weight-400 mt-3"
                        style={{ width: "100%" }}
                        key={index}
                        onClick={() => {
                          setDisplayEmployeeName(warning.employeeName);
                          setDisplaySsn(warning.ssn);
                          setDisplayPayDate(warning.payDate);
                          setDisplayEmployeeId(warning.id);
                          //onClick(allRecords, warning.id);
                        }}
                      >
                        <Col md="6" className="align-self-center black-text">
                          <Row className="ml-1"> {warning.employeeName}</Row>
                          <Row className="ml-1">
                            {" "}
                            {ssnMasking(warning.ssn)}{" "}
                          </Row>
                        </Col>
                        <Col md="3" className="align-self-center black-text">
                          {usDateFormat(warning.payDate)}
                        </Col>
                        <Col
                          md="3"
                          className="align-self-center black-text cursor-pointer"
                          style={{ color: "#06741A" }}
                        >
                          Accepted
                        </Col>
                      </Row>
                    ))}
                </div>
              </div>
              {
                <div
                  className="pl-3 ml-2 w-80"
                  style={
                    {
                      //width: "70%",
                      //height: "700px",
                      //borderLeft: "2px solid #b7b7b7",
                    }
                  }
                >
                  <div className="d-flex flex-column w-100 bg-grey header-padding">
                    <div className="d-flex flex-row">
                      <div className="fw-600 ft-18">{displayEmployeeName}</div>
                      &nbsp;&nbsp;
                      <div className="grey-text-sub align-self-center ft-16 fw-600">
                        {`(${ssnMasking(displaySsn)})`}
                      </div>
                    </div>
                    <div className="d-flex flex-row">
                      <div className="grey-text ft-14 fw-600">{`Pay date`}</div>
                      &nbsp;&nbsp;
                      <div className="ft-14 fw-600">
                        {usDateFormat(displayPayDate)}
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      width: "100%",
                      //height: "700px",
                      //borderLeft: "2px solid #b7b7b7",
                    }}
                  >
                    <Formik
                      initialValues={{
                        ...employeeData,
                        // country: "USA",
                        compensationDetailsRecordType: 0,
                        contributionDetailsRecordType: 0,
                        errorReportRecordType: 0,
                        payrollLoansRecordType: 0,
                      }}
                      initialErrors={errorList}
                      enableReinitialize
                      validateOnChange={false}
                      validateOnBlur={false}
                      validateOnMount={true}
                    >
                      {({
                        setFieldTouched,
                        handleSubmit,
                        setErrors,
                        values,
                        setFieldError,
                      }) => {
                        // const onTabChange = (index) => {
                        //   setCensusOrPayrollTab(index);
                        // };

                        const errorItemClick = (item, tab) => {
                          setFieldTouched(item.controlName, true);
                          // setCensusOrPayrollTab(tab);
                          window.setTimeout(() => {
                            // setErrors({ ...errors, [item.field]: item.message });

                            switch (item.controlName) {
                              case "employeeClassifications":
                                scrollToErrorControl(
                                  "employeeClassifications[0].code"
                                );
                                break;
                              case "ytdHours":
                                scrollToErrorControl(
                                  "hoursDetails[0].ytdHours"
                                );
                                break;
                              case "payPeriodHours":
                                scrollToErrorControl(
                                  "hoursDetails[0].payPeriodHours"
                                );
                                break;
                              case "payPeriodGrossCompensation":
                                scrollToErrorControl(
                                  "compensations[0].payPeriodAmount"
                                );
                                break;
                              case "payPeriodPlanCompensation":
                                scrollToErrorControl(
                                  "compensations[1].payPeriodAmount"
                                );
                                break;
                              case "ytdGrossCompensation":
                                scrollToErrorControl(
                                  "compensations[0].ytdAmount"
                                );
                                break;
                              case "ytdPlanCompensation":
                                scrollToErrorControl(
                                  "compensations[1].ytdAmount"
                                );
                                break;
                              case "contributionsDetails":
                                scrollToErrorControl(
                                  "contributions[0].contributionAmount"
                                );
                                break;
                              case "ytdContributionAmount":
                                scrollToErrorControl(
                                  "contributions[0].ytdContributionAmount"
                                );
                                break;
                              case "loanNumber":
                                scrollToErrorControl(
                                  "payrollLoans[1].loanNumber"
                                );
                                break;
                              case "loanDetails":
                                scrollToErrorControl(
                                  "payrollLoans[0].repaymentAmount"
                                );
                                break;
                              default:
                                scrollToErrorControl(item.controlName);
                                break;
                            }
                          }, 500);
                        };

                        // const disableStatus =
                        //   censusErrors.length + payrollErrors.length > 0 ||
                        //   censusWarnings.length + payrollWarnings.length > 0
                        //     ? true
                        //     : false;
                        // const handleClose = () => {
                        //   setModalOpen(false);
                        // };
                        const returnArrowClick = () => {
                          history.push(
                            getAdvancedPathWithParam({
                              path: `${ROUTES.PAYROLL_FILE_STATUS}/${payrollId}?`,
                              // pathParam: [FLOW_TYPES.ADD],
                            })
                          );
                        };

                        const handleBack = () => {
                          //setToggleEmp(!toggleEmp);
                          setErrorPage(false);
                          setModalOpen(false);
                          setIsSliderOpen(false);
                          setDataChangeValidations([]);
                        };

                        return (
                          <div style={{ height: "52vh", overflow: "scroll" }}>
                            <ManagePayrollTabLayout
                              returnArrow={false}
                              onReturnArrowClick={returnArrowClick}
                              noStep={true}
                              isDeleteRecord={false}
                              isCensusPayrollPage={false}
                              onPayrollDeleteClick={onPayrollDeleteClick}
                              labelrequired={false}
                              displayTitle={false}
                            >
                              <Form
                                autoComplete="off"
                                onSubmit={handleSubmit}
                                className="h-100 d-flex"
                              >
                                <div className="h-100 d-flex">
                                  <div className="payroll-census-tabs">
                                    <Tabs
                                      defaultActiveKey="Census"
                                      transition={false}
                                      className="top-level-tab-var w-100"
                                      onSelect={onCensusTabSelect}
                                      activeKey={censusTabIndex}
                                      mountOnEnter
                                      unmountOnExit
                                    >
                                      {[
                                        UploadedFileType.IsDemographyOnly,
                                        UploadedFileType.IsBothDemographyAndPayrollOnly,
                                      ].includes(fileTypeInformation) && (
                                        <Tab eventKey="census" title="Census">
                                          <CensusFormDetails
                                            setIsLoading={setIsLoading}
                                            errorList={errorList}
                                            countries={countries}
                                            states={states}
                                            frequencyList={frequencyList}
                                            fileType={payrollDetails.fileType}
                                            setFieldError={setFieldError}
                                            setErrorList={setErrorList}
                                            setFieldTouched={setFieldTouched}
                                            fields={fields}
                                            data={census ? employeeData : null}
                                            awaitingFunding={
                                              pendingSubmission ||
                                              !isAllowedUpdate()
                                            }
                                            errorItemClick={(item) =>
                                              errorItemClick(item, "census")
                                            }
                                            isStartDate={isStartDate}
                                            isEndDate={isEndDate}
                                            setErrors={setErrors}
                                            isWarningSlide={isModalOpen}
                                          />
                                        </Tab>
                                      )}
                                      {[
                                        UploadedFileType.IsPayrollOnly,
                                        UploadedFileType.IsBothDemographyAndPayrollOnly,
                                      ].includes(fileTypeInformation) && (
                                        <Tab eventKey="payroll" title="Payroll">
                                          <PayrollFormDetails
                                            setErrors={setErrors}
                                            errorList={errorList}
                                            isWarningSlide={isModalOpen}
                                            fields={fields}
                                            data={values}
                                            pendingSubmission={
                                              pendingSubmission ||
                                              !isAllowedUpdate()
                                            }
                                            errors={get(
                                              employeeData,
                                              "errorMessages",
                                              []
                                            )}
                                            warnings={get(
                                              employeeData,
                                              "warnings",
                                              []
                                            )}
                                            errorItemClick={(item) =>
                                              errorItemClick(item, "payroll")
                                            }
                                            setId={setDeleteContributionId}
                                            setError={
                                              setDeleteCompensationError
                                            }
                                            setHoursErrorId={setHoursErrorId}
                                          />
                                        </Tab>
                                      )}
                                    </Tabs>
                                  </div>
                                </div>
                              </Form>
                            </ManagePayrollTabLayout>
                          </div>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
              }
            </div>
          </div>
        </SliderPanel>
      </LoaderWrapper>
      <Toast
        onClose={() => setShowToastAll(false)}
        show={showToastAll}
        style={{
          position: "fixed",
          top: "4rem",
          right: "1rem",
          zIndex: "100",
        }}
        className="info-toast"
        delay={500000}
        autohide
      >
        <Toast.Body>
          <div className="d-flex justify-content-between">
            <div className="info-text">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#FF9716"
                className="pointer ft-24 tri-claim"
              />
              <span className="warning-text ft-12">All Warning Accepted</span>
            </div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                color="#000"
                onClick={() => setShowToastAll(false)}
                className="pointer"
              />
            </div>
          </div>
          <div className="d-flex justify-content-between mt-10">
            <div className="total-record">5 Records Accepted</div>
            <div className="warning-undo-btn" onClick={undoAll}>
              Undo
            </div>
          </div>
        </Toast.Body>
      </Toast>
      <Toast
        onClose={() => setShowToast(false)}
        show={showToast}
        style={{
          position: "fixed",
          top: "4rem",
          right: "1rem",
          zIndex: "99999",
        }}
        className="info-toast"
        delay={5000}
        autohide
      >
        <Toast.Body>
          <div className="d-flex justify-content-between">
            <div className="info-text">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#FF9716"
                className="pointer ft-24 tri-claim"
              />
              <span className="warning-text ft-12">Warning Accepted</span>
            </div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                color="#000"
                onClick={() => setShowToast(false)}
                className="pointer"
              />
            </div>
          </div>
          <div>
            <ul className="warning-list">
              {showAllToastMsg &&
                showAllToastMsg.map((warning) => <li>{warning.warning}</li>)}
            </ul>
          </div>
          <div className="d-flex justify-content-between">
            <div className="total-record">
              {showAllToastMsg &&
                showAllToastMsg[0] &&
                showAllToastMsg[0].warningCount}{" "}
              Records Accepted
            </div>
            <div className="warning-undo-btn" onClick={undo}>
              Undo
            </div>
          </div>
        </Toast.Body>
      </Toast>
    </div>
  );
};

export default WarningReports;
